module.exports = __webpack_public_path__ + "media/images/icon__compete@2x-e7b08cc1e22e6192451f47e57601793c.png";